export default class LinkHandler {
  handle = ({ variantId, productUrl }, node) => {
    this.updateLink(variantId, productUrl, node);
  };

  updateLink = (variantId, productUrl, node) => {
    const links = node.getElementsByClassName('js-product-card-link');

    [...links].forEach((link) => {
      link.setAttribute('href', `${productUrl}?variant=${variantId}`);
    });
  };
}
